// Scroll to top button functionality
document.addEventListener('DOMContentLoaded', function() {
  const pageTop = document.getElementById('page-top');
  
  if (pageTop) {
    pageTop.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});
